export default {"src":"/_next/static/media/radicchio.db731ef3.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};